<script>
  import Loader from 'shared/feedback/Loader/Loader.svelte'

  let { loader, params = {}, loadingFullScreen = true, ...rest } = $props()

  let componentPromise = $state(null)
  let lastLoader = null

  $effect(() => {
    if (!loader) {
      lastLoader = null
      componentPromise = null
      return
    }

    if (loader !== lastLoader) {
      lastLoader = loader
      componentPromise = loader()
    }
  })
</script>

{#if componentPromise}
  {#await componentPromise}
    <Loader fullScreen={loadingFullScreen} />
  {:then module}
    {@const Component = module.default}
    <Component {...params} {...rest} />
  {:catch error}
    {@const _logged = console.error('Error loading lazy component:', error)}
    <div class="p-4 text-sm text-red-600">Unable to load this content. Please try again later.</div>
  {/await}
{:else}
  <Loader fullScreen={loadingFullScreen} />
{/if}
